import { keyMirror } from '~/util/helpers/keyMirror'
import { AddressBookEntry } from './reducer'

export const ACTIONS = keyMirror(
  {
    UPDATE_ADDRESSBOOK_REQUESTED: null,
    UPDATE_ADDRESSBOOK_SUCCESS: null,
    UPDATE_ADDRESSBOOK_FAILURE: null,
  },
  'addressbook'
)

export const updateAddressBookRequested = (searchTerm: string = '') => ({
  type: ACTIONS.UPDATE_ADDRESSBOOK_REQUESTED,
  payload: searchTerm,
})

export const updateAddressBookSuccess = (addresses: AddressBookEntry[] = []) => ({
  type: ACTIONS.UPDATE_ADDRESSBOOK_SUCCESS,
  payload: {
    addresses,
  },
})

export const updateAddressBookFailure = (error: Error) => ({
  type: ACTIONS.UPDATE_ADDRESSBOOK_FAILURE,
  error: true,
  payload: error,
})
